import { BluSelect, BluTooltip } from '@bludata/components';
import { Box, FormControl, InputLabel, MenuItem, Stack } from '@mui/material';
import { FC, memo, useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MaxConcurrentAppointmentsInterface {
  disabled?: boolean;
}

export const MaxConcurrentAppointments: FC<MaxConcurrentAppointmentsInterface> =
  memo(({ disabled = false }) => {
    const maxConcurrentAppointments = useWatch({
      name: 'maxConcurrentAppointments',
    });

    console.log('maxConcurrentAppointments', maxConcurrentAppointments);

    const { setValue, trigger } = useFormContext();

    const setAppointmentProcess = useCallback(
      (event: any) => {
        setValue('maxConcurrentAppointments', event.target.value);
        trigger('maxConcurrentAppointments');
      },
      [setValue, trigger]
    );

    return (
      <Stack
        sx={{
          minWidth: '150px',
          flex: 1,
        }}
      >
        <FormControl>
          <Stack flex={1} direction="row" gap={1}>
            <InputLabel sx={{ flex: 1 }}>
              Limite appuntamenti per slot
            </InputLabel>
            <BluTooltip
              text={
                <Markdown
                  className="reactMarkDown"
                  remarkPlugins={[remarkGfm]}
                >{`Specifica il numero massimo di appuntamenti che possono essere prenotati nello stesso intervallo orario.   
                  Valori possibili:   
                - **Nessun limite fisso**:   il sistema calcola automaticamente il numero massimo prenotabile in base alla disponibilità dello studio e degli operatori.   
                - **Solo un appuntamento per slot** (modalità esclusiva).    
                - **Fino a due appuntamenti per slot.**  
                `}</Markdown>
              }
              sx={{
                p: '2px',
                pb: '4px',
                ml: '20px',
                backgroundColor: '#f5f5f5', // Colore di sfondo predefinito
                '.dark-mode-bludata &': {
                  backgroundColor: '#404040', // Colore di sfondo in modalità dark
                },
                '& svg': { width: '15px!important', height: '15px!important' },
              }}
            />
          </Stack>

          <BluSelect
            value={maxConcurrentAppointments}
            onChange={setAppointmentProcess}
            disabled={disabled}
            renderValue={(selected: any) => {
              console.log('selected', selected);
              let text = 'Gestione automatica della disponibilità';
              if (selected === 1) text = 'Appuntamento esclusivo per slot';
              if (selected === 2) text = 'Fino a due appuntamenti per slot';
              return (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {text}
                </Box>
              );
            }}
          >
            <MenuItem key={0} value={0}>
              Gestione automatica della disponibilità
            </MenuItem>
            <MenuItem key={1} value={1}>
              Appuntamento esclusivo per slot
            </MenuItem>
            <MenuItem key={2} value={2}>
              Due appuntamenti per slot
            </MenuItem>
          </BluSelect>
        </FormControl>
      </Stack>
    );
  });
